import { ReactNode } from "react";
import { Box } from "@mui/material";
import ShadowedButton from "@components/ShadowedButton";

const PaymentButton = ({
    label,
    icon,
    sx,
    iconPath,
    isSelected = false,
    isDisabled = false,
    onClick = () => {},
}: {
    label: string;
    icon?: ReactNode;
    iconPath?: string;
    isSelected?: boolean;
    isDisabled?: boolean;
    sx?: object;
    onClick?: () => void;
}) => {
    return (
        <ShadowedButton
            size="small"
            variant="outlined"
            startIcon={
                iconPath ? (
                    <Box
                        component="img"
                        sx={{
                            width: "25px",
                            height: "22px",
                            display: "block",
                        }}
                        src={iconPath}
                        alt="Logo loading..."
                    />
                ) : (
                    icon
                )
            }
            sx={{
                fontSize: "14px",
                width: 80,
                height: 38,
                fontWeight: "500",
                margin: 1,
                borderRadius:'4px',
                color: isSelected ? "#ce1337" : "#434E5A",
                borderColor: isSelected ? "#ce1337" : "#d9dddf",
                borderWidth: isSelected ? 1.5 : 0.75,
                "&:hover": {
                    backgroundColor: "#fff",
                    color: "#ce1337", // Change text color on hover
                    borderColor: "#ce1337", // Change border color on hover
                    borderWidth: 1.5, // Optional: Adjust border thickness on hover
                    cursor: "pointer", // Optional: Change cursor to pointer
                },
            }}
            // color="primary"
            onClick={onClick}
            disabled={isDisabled}
        >
            {label}
        </ShadowedButton>
    );
};

export default PaymentButton;
